import { QUOTAS, UsageFieldsMapping } from "../../../../consts";
import { hasSubscription } from "../../helpers/organization";

/**
 * Footer quota numbers — same source QuotaSubheader already reads
 * (org usage + subscription quota), just reshaped for the
 * "X of Y integrations used · Z left" footer copy.
 *
 * @param {object} currentOrganization
 * @returns {{used: number, limit: number, left: number, unlimited: boolean, atLimit: boolean, blockedByPlan: boolean} | null}
 */
export const getQuotaSummary = (currentOrganization) => {
  const subscription = hasSubscription(currentOrganization);

  if (!subscription || !subscription.quotas) {
    return null;
  }

  const used = Number(
    currentOrganization.model?.usage?.[UsageFieldsMapping[QUOTAS.integrations]] || 0
  );
  const limit = Number(subscription.quotas[QUOTAS.integrations]);
  const unlimited = limit === -1;
  const left = unlimited ? null : Math.max(limit - used, 0);
  const atLimit = !unlimited && used >= limit;

  return {
    used,
    limit,
    left,
    unlimited,
    atLimit,
    blockedByPlan: atLimit,
  };
};

export default getQuotaSummary;
